module.exports = __webpack_public_path__ + "static/media/icus-8.7a0bbe72.png";